import { AsDoctor } from "./access-as/as-doctor/as-doctor";
import { LoginNeeded } from "./needed-action/login-needed/login-needed";
import { BecomeMedic } from "./needed-action/student-need-to/become-medic/become-medic";
import { NoDoctor } from "./dead-end/no-doctor/no-doctor";
import { NoDrugAdRecipient } from "./dead-end/no-drug-ad-recipient/no-drug-ad-recipient";
import { SetSpecialization } from "./needed-action/doctor-need-to/set-specialization/set-specialization";
import { SetStatus } from "./needed-action/doctor-need-to/set-status/set-status";
import { NoStudent } from "./dead-end/no-student/no-student";
import { Consumer } from "./dead-end/consumer/consumer";
import { SignOnNewsletter } from "./needed-action/sign-on-newsletter/sign-on-newsletter";
import { ConfirmNewsletter } from "./needed-action/confirm-newsletter/confirm-newsletter";
import { Business } from "./dead-end/business/business";
import { NoDoctorOrStudent } from "./dead-end/no-doctor-or-student/no-doctor-or-student";
import { DoctorSpecialization } from "./dead-end/doctor-specialization/doctor-specialization";
import { EnablePrescription } from "./needed-action/nurse-or-midwife-need-to/enable-prescription";
import { ClubSubscription } from "./needed-action/club-subscription/club-subscription";
import { ActionName, PermissionComponentType } from "./types";

type StaticPermissionMap = Partial<Record<ActionName, PermissionComponentType>>;

const STATIC_PERMISSION_MAP: StaticPermissionMap = {
  review_status: AsDoctor,
  login: LoginNeeded,
  doctor_specialization: DoctorSpecialization,
  if_specialization: SetSpecialization,
  if_doctor_complete_doctor_status: SetStatus,
  only_for_students: NoStudent,
  content_consumer: Consumer,
  newsletter: SignOnNewsletter,
  confirm_newsletter: ConfirmNewsletter,
  business: Business,
  doctor_or_student: NoDoctorOrStudent,
  club_subscription: ClubSubscription,
};

interface ActionFlags {
  isStudent: boolean;
  isNurseOrMidwife: boolean;
}

function getDoctorOrDentistComponent(
  isStudent: boolean,
): PermissionComponentType {
  return isStudent ? BecomeMedic : NoDoctor;
}

function getDrugAdRecipientComponent({
  isStudent,
  isNurseOrMidwife,
}: ActionFlags): PermissionComponentType {
  if (isStudent) {
    return BecomeMedic;
  }
  return isNurseOrMidwife ? EnablePrescription : NoDrugAdRecipient;
}

export function getPermissionComponent(
  actionName: ActionName,
  flags: ActionFlags,
): PermissionComponentType | null {
  if (actionName === "doctor_or_dentist") {
    return getDoctorOrDentistComponent(flags.isStudent);
  }

  if (actionName === "drug_ad_recipient") {
    return getDrugAdRecipientComponent(flags);
  }

  return STATIC_PERMISSION_MAP[actionName] ?? null;
}
